import { RootPaths } from "@src/appV2/App/paths";

import {
  ADD_LICENSE_PATH,
  ADD_QUALIFICATION_MODAL_PATH,
  ADD_STATE_MODAL_PATH,
  LICENSE_DUPLICATE_MODAL_PATH,
  LICENSE_ERROR_MODAL_PATH,
  LICENSE_IN_REVIEW_MODAL_PATH,
  SUBMITTING_LICENSE_MODAL_PATH,
} from "../../Roles/AddLicense/paths";
import {
  REMOVE_LICENSE_MODAL_PATH,
  REMOVE_ROLE_MODAL_PATH,
  RENEW_LICENSE_MODAL_PATH,
} from "../../Roles/paths";

export const ACCOUNT_ROLES_PATH = "roles";
export const ACCOUNT_ROLE_DETAILS_PATH = ":qualificationId";
export const ACCOUNT_ADD_ROLES_PATH = "add";

export const ACCOUNT_ROLES_FULL_PATH = `${RootPaths.APP_V2_HOME}/accounts/roles`;
export const ACCOUNT_ROLE_DETAILS_FULL_PATH = `${RootPaths.APP_V2_HOME}/accounts/roles/:qualificationId`;
export const ACCOUNT_ADD_ROLE_FULL_PATH = `${RootPaths.APP_V2_HOME}/accounts/roles/add`;

export const ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH = `${ACCOUNT_ROLE_DETAILS_FULL_PATH}/${ADD_LICENSE_PATH}`;
export const ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ADD_STATE_MODAL_FULL_PATH = `${ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH}/${ADD_STATE_MODAL_PATH}`;
export const ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ADD_QUALIFICATION_MODAL_FULL_PATH = `${ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH}/${ADD_QUALIFICATION_MODAL_PATH}`;
export const ACCOUNT_ROLE_DETAILS_ADD_LICENSE_SUBMITTING_MODAL_FULL_PATH = `${ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH}/${SUBMITTING_LICENSE_MODAL_PATH}`;
export const ACCOUNT_ROLE_DETAILS_ADD_LICENSE_IN_REVIEW_MODAL_FULL_PATH = `${ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH}/${LICENSE_IN_REVIEW_MODAL_PATH}`;
export const ACCOUNT_ROLE_DETAILS_ADD_LICENSE_DUPLICATE_MODAL_FULL_PATH = `${ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH}/${LICENSE_DUPLICATE_MODAL_PATH}`;
export const ACCOUNT_ROLE_DETAILS_ADD_LICENSE_ERROR_MODAL_FULL_PATH = `${ACCOUNT_ROLE_DETAILS_ADD_LICENSE_FULL_PATH}/${LICENSE_ERROR_MODAL_PATH}`;

export const ACCOUNT_ROLE_DETAILS_REMOVE_LICENSE_MODAL_PATH = `${ACCOUNT_ROLE_DETAILS_FULL_PATH}/${REMOVE_LICENSE_MODAL_PATH}`;
export const ACCOUNT_ROLE_DETAILS_REMOVE_ROLE_MODAL_PATH = `${ACCOUNT_ROLE_DETAILS_FULL_PATH}/${REMOVE_ROLE_MODAL_PATH}`;
export const ACCOUNT_ROLE_DETAILS_RENEW_LICENSE_MODAL_PATH = `${ACCOUNT_ROLE_DETAILS_FULL_PATH}/${RENEW_LICENSE_MODAL_PATH}`;
